import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import './CategoryCarousel.css';

const CategoryCarousel = ({ categorias = [] }) => {
  const carouselRef = React.useRef(null);

  const scroll = (direction) => {
    const container = carouselRef.current;
    if (!container) return;

    const cardWidth = 200; // largura aproximada de cada card + gap
    const scrollAmount = cardWidth * 4; // rolar 4 cards por vez

    if (direction === 'next') {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  };

  if (!categorias || categorias.length === 0) {
    return null;
  }

  return (
    <div className="category-carousel-section">
      <div className="category-carousel-header">
        <h2 className="category-carousel-title">Categorias</h2>
        <Link to="/produtos" className="show-all-categories-link">
          Mostrar todas as categorias
        </Link>
      </div>
      
      <div className="category-carousel-wrapper">
        <div className="category-carousel-container" ref={carouselRef}>
          {categorias.map((categoria) => (
            <Link
              key={categoria.id}
              to={`/produtos?categoria=${encodeURIComponent(categoria.nome)}`}
              className="category-carousel-card"
            >
              <div className="category-card-image">
                {categoria.icone ? (
                  <div className="category-icon-emoji">{categoria.icone}</div>
                ) : (
                  <div className="category-icon-placeholder">
                    {categoria.nome.charAt(0).toUpperCase()}
                  </div>
                )}
              </div>
              <div className="category-card-name">
                {categoria.nome}
              </div>
            </Link>
          ))}
        </div>
        
        <button
          className="category-carousel-button category-carousel-button-next"
          onClick={() => scroll('next')}
          aria-label="Próximas categorias"
        >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default CategoryCarousel;

